/**
 * The one way an engine says a money figure in a sentence: whole dollars with a thousands comma,
 * two places, a minus sign before the dollar. A figure, not a time (ADR 0006 is about times);
 * the screens use `@cider/ui`'s `formatMoney`, which agrees with this to the character.
 */
export const dollars = (cents: number): string => {
  const whole = Math.floor(Math.abs(cents) / 100)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return `${cents < 0 ? '−' : ''}$${whole}.${String(Math.abs(cents) % 100).padStart(2, '0')}`;
};
